<template>
    <!-- 对话框 -->
    <el-drawer title="添加商家信息"  @opened="opened" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px">

        <!-- 基本信息表单 -->
        <div class="form-box">


            <template>

                <el-form ref="form" :model="submit_data" label-width="80px" style="height: 90vh; overflow-y: auto;">

                    <el-form-item label="状态:" label-width='120px'>
                        <el-select
                                v-model="submit_data.status"
                                placeholder="请选择状态"
                                style="width: 150px; margin-right: 20px;"
                                clearable
                        >
                            <el-option label="启用" value="1"
                            >
                            </el-option>
                            <el-option label="禁用" value="0"
                            >
                            </el-option>
                        </el-select>

                    </el-form-item>


                    <el-form-item label="分润模式配置:" label-width='120px'>
                        <div style="display:flex;">
                            <el-select
                                    v-model="submit_data.type"
                                    :placeholder="submit_rules.type.placeholder"
                                    style="width: 150px; margin-right: 20px;"
                                    clearable
                            >
                                <el-option
                                        label="百分比"
                                        value="1"
                                >
                                </el-option>
                                <el-option
                                        label="金额"
                                        value="0"
                                >
                                </el-option>
                            </el-select>
                            <!-- 分润模式配置不为空时展示如下输入框，如果分润模式为百分比，则输入框后面的单位是% 否则为元 -->
                            <div v-if="submit_data.type!=''">
                                <el-input v-model="submit_data.share_money" :placeholder="submit_rules.share_money.placeholder"
                                          style="width: 100px; margin-right:5px"></el-input>
                                {{submit_data.type == '1'?'%':'元'}}
                            </div>
                        </div>
                    </el-form-item>

                    <el-form-item label="司机承担:" label-width='120px'>
                        <el-input v-model="submit_data.driver_bear" :placeholder="submit_rules.driver_bear.placeholder" style="width: 150px; margin-right:5px">
                        </el-input>元
                    </el-form-item>



                    <el-form-item label="指定计费模式:" label-width='120px'>
                        <el-select
                                v-model="value_mode_code"
                                placeholder="请选择模式"
                                @visible-change="modeVisibleChange"
                                @change="modeChange"
                                clearable
                                filterable
                                style="width: 150px; margin-right: 20px;"
                        >
                            <el-option
                                    v-for="item in options_mode_code"
                                    :key="item.value"
                                    :label="item.order_mode.name"
                                    :value="item.order_mode.order_mode_code"
                            >
                            </el-option>

                            <selectPages
                                    :search_data="mode_options_data"
                                    :result_data="selectPages_data"
                                    @selectPages_function="selectPages_function"
                            ></selectPages>

                        </el-select>

                    </el-form-item>

                    <el-form-item label="代叫费:" label-width='120px' style="margin-bottom: 0">
                        <el-input v-model="submit_data.consumer_bear" :placeholder="submit_rules.consumer_bear.placeholder" style="width: 150px; margin-right:5px">
                        </el-input>
                        元
                    </el-form-item>
                    <div style="font-size: 12px;text-indent:120px;margin-bottom: 20px">乘客承担，商家每单分成收入</div>


                    <div class="bottom-box">

                        <el-form-item label="渠道优惠金额:" label-width='120px'>
                            <el-input v-model="submit_data.offer_amount" style="width: 150px; margin-right:5px">
                            </el-input>
                            元
                        </el-form-item>
                        <el-form-item label="优惠次数:" label-width='120px'>
                            {{submit_data.offer_number}}
                            次
                        </el-form-item>
                        <el-form-item label="调整次数:" label-width='120px'>
                            <el-input v-model="edit_amount" style="width: 150px; margin-right:5px">
                            </el-input>
                            <el-radio-group v-model="amount_radio">
                                <el-radio-button label="add">+</el-radio-button>
                                <el-radio-button label="sub">-</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="参与用户:" label-width='120px'>
                            <el-select
                                    v-model="submit_data.face_new"
                                    style="width: 150px; margin-right: 20px;"
                                    clearable
                            >
                                <el-option label="所有用户" value="0">
                                </el-option>
                                <el-option label="新用户" value="1">
                                </el-option>
                                <el-option label="老用户" value="2">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="优惠满足条件:" label-width='120px'>
                            <div class="item-wrap">
                                <el-input v-model="submit_data.order_limit" style="width: 150px; margin-right:5px">
                                </el-input>
                                小时内下单
                            </div>
                            <div class="item-wrap">
                                <el-input v-model="submit_data.finish_limit" style="width: 150px; margin-right:5px">
                                </el-input>
                                小时内完成订单
                            </div>
                            <div class="item-wrap">
                                <el-input v-model="submit_data.pay_limit" style="width: 150px; margin-right:5px">
                                </el-input>
                                小时内支付订单
                            </div>

                        </el-form-item>
                        <el-form-item label="设置参与活动起点半径:" label-width='180px'>
                            <el-input v-model="submit_data.radius" style="width: 150px; margin-right:5px">
                            </el-input>
                            米
                        </el-form-item>


                    </div>

                    <el-form-item label="店面位置信息:" label-width='180px'>

                        <div class="edit-address" v-if="editAddress">
                            <el-input v-model="submit_data.name" @input="addressInput()" style="width: 150px; margin-right:5px">
                            </el-input>
                            <div class="pos-box">
                                <div class="item" v-for="(item,index) in address_list" :key="index" @click="addressChange(item)">
                                    {{item.title}}
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            {{submit_data.name}}
                            <el-button type="text" @click="editAddress = true">修改</el-button>
                        </div>


                    </el-form-item>

                    <div id="edit-container" class="map"></div>
                    <!-- 当有商家名字的时候才显示审核，当审核通过后禁用审核功能,在调取商家详情接口的时候判断是否有商家名称
                    如果有商家名字，证明该商家码已被商家扫码并申请绑定，此时需要显示审核功能 -->

                    <!-- <el-form-item label="审核:" label-width='120px' v-if="flag!=''">

                     <el-select
                    v-model="submit_data.audit_status"
                    placeholder="请选择审核状态"
                    style="width: 150px; margin-right: 20px;"
                    clearable
                    :disabled="is_disabled == '1'"
                    >

                        <el-option label="待审核" value="0"
                        >
                        </el-option>
                        <el-option label="通过" value="1"
                        >
                        </el-option>
                        <el-option label="驳回" value="2"
                        >
                        </el-option>
                    </el-select>
                </el-form-item> -->







                </el-form>


                <!-- 对话框底部按钮 -->
                <div style="display: flex;justify-content: center">
                    <el-button @click="onSubmitDig" type="primary">确认</el-button>
                    <el-button @click="closeDialog">关闭</el-button>
                </div>

            </template>


        </div>


    </el-drawer>
</template>

<script>

    var _this,map,markPoint;
    export default {
        props: {
            'isShow': Boolean,
            'data':''
        },
        watch: {

            isShow(newData, oldData) {

                _this.show = true;
                _this.submit_data.business_code = _this.data;





            }
        },
        data() {
            return {


                show: false,

                is_disabled:false,

                address_list:[],

                area_code:'',

                editAddress:false,

                edit_amount:'',
                amount_radio:'',

                flag:'',

                value_mode_code: '',

                options_mode_code: [],

                mode_options_data: {
                    page: 1,
                    limit: 5,
                    status: '1'
                },

                selectPages_data: [],

                submit_url: '/business/editBusiness',

                // 编辑页面表单数据
                submit_data: {

                    business_code: '',
                    type: '',
                    share_money: '',
                    driver_bear: '',
                    face_new: '',
                    order_mode_code: '',
                    status: '',
                    audit_status:'',
                    consumer_bear: '',
                    offer_amount: '',
                    offer_number: '',
                    order_limit: '',
                    finish_limit: '',
                    pay_limit: '',
                    radius: '',
                    name:''


                },

                // 编辑页面表单验证规则
                submit_rules: {

                    type: {
                        placeholder: '分润模式',
                        rules: {
                            required: true,
                            message: '模式错误',
                            regulation: 'gt_str',
                            rulesData: '0|1'
                        }
                    },
                    share_money: {
                        placeholder: '金额或比例',
                        rules: {
                            required: true,
                            message: '分润金额或比例为不小于0的数字',
                            regulation: 'egt',
                            rulesData: 0
                        }
                    },
                    driver_bear: {
                        placeholder: '司机承担',
                        rules: {
                            required: true,
                            message: '司机承担为不小于0的正整数',
                            regulation: 'int',
                            rulesData: 0
                        }
                    },
                    face_new: {
                        placeholder: '活动指定人群',
                        rules: {
                            required: true,
                            message: '是否限制为新用户',
                            regulation: 'gt_str',
                            rulesData: '0|1'
                        }
                    },
                    order_mode_code: {
                        placeholder: '请选择计费模式',
                        rules: {
                            required: false,
                            message: '计费模式',
                            regulation: 'gt_str',
                            rulesData: '0'
                        }
                    },

                    consumer_bear: {
                        placeholder: '乘客承担',
                        rules: {
                            required: false,
                            message: '代叫费需为正整数',
                            regulation: 'int',
                            rulesData: 0
                        }
                    },
                    offer_amount: {
                        placeholder: '',
                        rules: {
                            required: false,
                            message: '渠道优惠金额需为正整数',
                            regulation: 'int',
                            rulesData: 0
                        }
                    },
                    order_limit:{
                        placeholder: '',
                        rules: {
                            required: false,
                            message: '小时内下单需为正整数',
                            regulation: 'int',
                            rulesData: 0
                        }
                    },
                    finish_limit:{
                        placeholder: '',
                        rules: {
                            required: false,
                            message: '小时内完成订单需为正整数',
                            regulation: 'int',
                            rulesData: 0
                        }
                    },
                    pay_limit:{
                        placeholder: '',
                        rules: {
                            required: false,
                            message: '小时内支付订单需为正整数',
                            regulation: 'int',
                            rulesData: 0
                        }
                    },
                    radius:{
                        placeholder: '',
                        rules: {
                            required: false,
                            message: '参与活动起点半径需为正整数',
                            regulation: 'int',
                            rulesData: 0
                        }
                    }

                },

            };
        },
        created() {

            _this = this;

        },
        methods: {
            // 添加mark点方法
            addMark(lng,lat){
                if(markPoint){
                    // 移除已创建的 marker
                    markPoint.setGeometries([])
                }
                var markPoint = new TMap.MultiMarker({
                    map: map,
                    styles: {
                    "pointStyle": new TMap.MarkerStyle({
                        "width": 22,
                        "height": 38,
                        "src": require(`@/assets/mark-icon.png`)
                    })
                },
                geometries: [{
                    "id": "point_marker",
                    "styleId": "pointStyle",
                    "position": new TMap.LatLng(lat, lng),
                    "draggable": false,
                    "properties": {
                        "title": "定位标记"
                    }
                }]
                });
                // 图自适应中心点
                map.setCenter(new TMap.LatLng(lat, lng));
            },


            addressChange(val){
                //  添加地图标记点
                console.log(val);

                _this.addMark(val.location.lng, val.location.lat);

                _this.submit_data.name = val.title;
                _this.address_list = [];

                _this.submit_data.business_coordinate = val.location.lng+','+val.location.lat


            },
            addressInput(){
                _this.address_list = [];
                if(_this.submit_data.name!=''){
                        var options = {
                            keyword: _this.submit_data.name,
                            cityName: _this.area_code
                        };

                        var search = new TMap.service.Search();
                        console.log(options);
                        search.searchRegion(options).then(function(result) {
                            console.log(result);
                            if (result) {
                                for (let i = 0; i < result.data.length; i++) {
                                    // console.log(result.poiList.pois[i],'列表数据');

                                    // 添加列表内容




                                        _this.address_list.push(result.data[i]);
                                        //  添加地图标记点
                                        //  markPoint
                                        // var markPointIcon = new AMap.Icon({
                                        //     // 图标尺寸
                                        //     size: new AMap.Size(25, 34),
                                        //     // 图标的取图地址
                                        //     image: require(`@/assets/markPoint${i + 1}.png`),
                                        //     // 图标所用图片大小
                                        //     imageSize: new AMap.Size(30, 30),
                                        //     // 图标取图偏移量
                                        //     imageOffset: new AMap.Pixel(0, 0)
                                        // });
                                        //
                                        // // console.log(result);
                                        // // 将 icon 传入 marker
                                        // _this.markPoint[i] = new AMap.Marker({
                                        //     position: new AMap.LngLat(result.poiList.pois[i].location.lng, result.poiList.pois[i].location.lat),
                                        //     icon: markPointIcon,
                                        //     draggable: false,
                                        //     offset: new AMap.Pixel(-13, -30),
                                        //     zIndex: 999
                                        // });
                                        //
                                        // _this.markPoint[i].setMap(map);
                                    }



                            }
                        })

                }

            },

            opened() {
                map = new TMap.Map("edit-container", {
                    resizeEnable: true,
                    zoom: 11
                });

                // 请求详情接口
                _this.getDetailsBusiness();

                _this.$post(
                    '/admin.php/city/getCityDetails'
                ).then(res => {
                    if (res.data.area_code.length == 4) {
                        _this.area_code = String(res.data.area_code) + '00';
                    } else {
                        _this.area_code = String(res.data.area_code);
                    }
                })

            },

            // 关闭方法
            closeDialog() {
                _this.show = false;


                //点击关闭按钮触发的方法，重置编辑页面表单数据
                _this.submit_data = {

                    business_code: '',
                    type: '',
                    share_money: '',
                    driver_bear: '',
                    face_new: '',
                    order_mode_code: '',
                    status: '',
                    audit_status:'',
                    consumer_bear: '',
                    offer_amount: '',
                    offer_number: '',
                    order_limit: '',
                    finish_limit: '',
                    pay_limit: '',
                    radius: '',
                    name:''


                }

                _this.edit_amount = '';
                _this.amount_radio = '';
                _this.flag = ''
                _this.editAddress = false;

            },



            //商家详情
            getDetailsBusiness(){
                _this.$post(
                    "/business/viewBusiness",{
                        business_code:_this.submit_data.business_code
                    },
                ).then(res => {


                    _this.flag = res.data.name;
                    _this.submit_data.type = res.data.type;
                    _this.submit_data.driver_bear = res.data.driver_bear;
                    _this.submit_data.face_new = res.data.face_new;
                    _this.submit_data.order_mode_code = res.data.order_mode_code;
                    _this.submit_data.share_money = res.data.share_money;
                    _this.submit_data.status = res.data.status;
                    _this.submit_data.audit_status = res.data.audit_status;
                    _this.value_mode_code = res.data.order_mode_name;
                    _this.is_disabled = res.data.audit_status;
                    _this.submit_data.consumer_bear = res.data.consumer_bear;
                    _this.submit_data.offer_amount = res.data.offer_amount;
                    _this.submit_data.offer_number = res.data.offer_number;
                    _this.submit_data.order_limit = res.data.order_limit;
                    _this.submit_data.finish_limit = res.data.finish_limit;
                    _this.submit_data.pay_limit = res.data.pay_limit;

                    _this.submit_data.radius = res.data.radius;


                    _this.submit_data.name = res.data.name;
                    _this.submit_data.business_coordinate = res.data.business_coordinate;

                    _this.addMark(res.data.business_coordinate.split(',')[0],res.data.business_coordinate.split(',')[1])

                }).catch((err) => {

                })


            },

            //搜索的下拉框弹出触发
            modeVisibleChange(val) {
                _this.orderModeList();
            },

            modeChange(val) {
                _this.submit_data.order_mode_code = val;
            },



            selectPages_function(search_data) {
                _this.mode_options_data = search_data;

                _this.orderModeList();
            },

            // 搜索订单列表
            orderLists() {
                _this.tableData = [];

                _this
                    .$post('/order/orderHistory', _this.search_data, _this.search_rules)
                    .then((res) => {
                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;



                        _this.platform_select_array = res.data[0].platform.select_array;
                        _this.port_select_array = res.data[0].port.select_array;
                        _this.vip_select_array = res.data[0].consumer_vip.select_array;
                        _this.is_new_visit_array = res.data[0].is_new_visit.select_array;

                        // console.log(_this.tableData[0].platform);


                    })
                    .catch((err) => {});
            },

            orderModeList() {
                // 请求公司管理接口获取公司唯一编码
                _this
                    .$post('/order/orderModeLists', _this.mode_options_data)
                    .then((res) => {
                        _this.selectPages_data = res;
                        _this.options_mode_code = res.data;
                    })
                    .catch((err) => {});
            },

            editAmountForm(){
                var reg = /^-?\d+$/;
                if(!reg.test(_this.edit_amount) || !(_this.edit_amount >= 0)){
                    _this.$message.error('调整次数需为正整数');

                    return false;
                }else{
                    return true;
                }
            },

            onSubmitDig(){
                console.log(_this.submit_data.offer_number);
                console.log(_this.submit_data.offer_number>_this.edit_amount);

                if(_this.amount_radio == 'add'){
                    if(!_this.editAmountForm()){
                        return false;
                    }
                    _this.submit_data.offer_number = Number(_this.submit_data.offer_number) + Number(_this.edit_amount);
                }else if(_this.amount_radio == 'sub' && Number(_this.submit_data.offer_number) >= Number(_this.edit_amount)){


                    if(!_this.editAmountForm()){
                        return false;
                    }
                    _this.submit_data.offer_number = Number(_this.submit_data.offer_number)-Number(_this.edit_amount);
                }else if(_this.amount_radio == 'sub' && Number(_this.submit_data.offer_number) < Number(_this.edit_amount)){
                    _this.$message.error('调整次数不能大于优惠次数');
                    return false;
                }


                _this.$post(
                    '/business/editBusiness',
                    _this.submit_data,
                    _this.submit_rules
                ).then(res => {
                    // 触发父组件自定义事件刷新表格
                    _this.$emit('onSubmit');
                    _this.$message.success(res.msg)
                    _this.closeDialog();
                });





            },



        }
    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .el-form-second {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .avatar-uploader {
        width: 100px;
        height: 100px;
    }
    .item-wrap{
        margin-bottom: 10px;
    }
    .map{
        width: 100%;
        height: 300px;
        z-index: 0;
    }
    .edit-address{
        position: relative;

    }
    .edit-address .pos-box{
        position: absolute;
        left: 0;
        top: 33px;
        width: 100%;
        z-index: 999;
        border-radius: 10px;
        overflow: hidden;
    }
    .edit-address .item{
        width: 100%;
        background-color: #F6F6F6;
        height: 50px;
        line-height: 50px;
        padding: 0 10px;
        box-sizing: border-box;
        cursor: pointer;
    }
</style>
